import { ReactElement } from "react";
import { CarbonSectionInputData } from "./CarbonSection";

export interface ICarbonSection {
    type: CarbonSectionType;
    data: CarbonSectionInputData;
    title: string;
    description: ReactElement;
    inputLabel: string;
}

export enum CarbonSectionType {
    CAR,
    TRAIN,
    AEROPLANE
}
